import { Star } from 'lucide-react';

/** Read-only or interactive 1-5 star rating. Gold fill matches LXRA chrome
 * (rating stars are not studio-accent-scoped — consistent everywhere they appear). */
export const StarRating = ({ value = 0, size = 'h-4 w-4', interactive = false, onChange, testId }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div data-testid={testId} className="inline-flex items-center gap-0.5">
      {stars.map((s) => {
        const filled = s <= Math.round(value || 0);
        if (!interactive) {
          return <Star key={s} className={`${size} ${filled ? 'fill-[hsl(var(--lxra-gold))] text-[hsl(var(--lxra-gold))]' : 'text-[hsl(var(--lxra-border))]'}`} />;
        }
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange?.(s)}
            aria-label={`Rate ${s} star${s > 1 ? 's' : ''}`}
            data-testid={testId ? `${testId}-${s}` : undefined}
            className="cursor-pointer transition-transform duration-150 hover:scale-110 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--lxra-gold))] rounded"
          >
            <Star className={`${size} ${filled ? 'fill-[hsl(var(--lxra-gold))] text-[hsl(var(--lxra-gold))]' : 'text-[hsl(var(--lxra-border))]'}`} />
          </button>
        );
      })}
    </div>
  );
};
